(function() {
	'use strict';
	angular.module('app.core')
		.controller('a3', a3);
	
	a3.$inject = ['$scope', '$filter', '$sce', '$uibModal','$timeout', 
		'a3Service', 'projectNdx', 'factoryNdx', 'closeA3'];
	function a3 ($scope, $filter, $sce, $uibModal,	$timeout,
			a3Service, projectNdx, factoryNdx, closeA3) {
		var vm = this;
		if (!factoryNdx) factoryNdx = globalConfig.factory.id;
		vm.hasDescription = false;
		vm.currencySymbol = globalConfig.browser.currencySymbol;
		vm.projectNdx = projectNdx;
		vm.projectGeneralData = null;
		vm.projectGoals = null;
		vm.projectTeam = null;
		vm.projectIssues = null;
		vm.projectTasksStarted = null;
		vm.projectTasksAccomplished = null;
		vm.projectTasksPending = null;
		vm.renderedDescription = '';
		vm.factoryName = globalConfig.factory.name;
		vm.reviewDays = '';
		vm.hasGoals = false; 
		vm.hasIssues = false;
		vm.hasCurrentActivity = false;
		vm.hasAccomplishments = false;
		vm.hasDocuments = false;
		vm.hasPendingTasks = false;
		vm.projectDocuments = null;
		vm.hasTasks = false;
		vm.closeA3Dialog = closeA3Dialog;
		vm.showMore = showMore;
		vm.savingsGroups = {
			'target': {
				'included': [],
				'notIncluded': []
			},
			'actual': {
				'included': [],
				'notIncluded': []
			}
		};
		vm.sectionMap = {
			'teamSection': {
				'shown': false,
				'text': 'Show Description, Team Members and Strategic Goals'
			}
		};
		vm.isProjectSavingsByCategory = false;
		
		vm.isAfterToday = isAfterToday;
		vm.printPage = printPage;
		vm.toggleTeam = toggleTeam;
		vm.openDetail = openDetail;
		vm.openDocument = openDocument;
		
		function init() {
			vm.isSupplier = globalConfig.user.role == 'Supplier';
			jQuery('body>div').addClass('no-print-on-a3');
			jQuery('#a3FullScreen').removeClass('no-print-on-a3');
			incomingData.initiativeNdx = projectNdx;
			incomingData.factory = factoryNdx;
			a3Service.getStartAndEndDates(factoryNdx).then(function (data) {
				incomingData.beginDate = data.startDate;
				incomingData.endDate = data.endDate;
			});
			
			a3Service.getFactorySettings(factoryNdx).then(function (data) {
				vm.reviewDays = data != null ? data[factoryNdx] : '';
			});
			
			a3Service.getProjectGeneralData(projectNdx, factoryNdx).then(function (data) {
				vm.currencySymbol = data.targetCurrency;
				vm.projectGeneralData = data.project;
				vm.hasDescription = vm.projectGeneralData.description ? true : false;
				vm.renderedDescription = $sce.trustAsHtml(vm.projectGeneralData.description);
				var rex = /(<([^>]+)>)/ig;
				vm.projectGeneralData.description = vm.projectGeneralData.description.replace(rex, ' ');
				vm.hasGoals = (vm.projectGeneralData.goals && vm.projectGeneralData.goals.length) > 0 ? true : false;
				vm.projectGoals = vm.projectGeneralData.goals;
				vm.projectGeneralData.status = vm.projectGeneralData.completeFlag && vm.projectGeneralData.stageSequence != 1000 ? 'complete' : vm.projectGeneralData.status;
				vm.isProjectSavingsByCategory = true;
				if (vm.isProjectSavingsByCategory) {
					a3Service.getProjectSavingsByCategory(factoryNdx, projectNdx).then(function (savingsData) {
						if (savingsData && savingsData['projectsSavingsByCategory']) {
							setSavingsByCategory(savingsData.projectsSavingsByCategory);
						}
					});
				}
			});
			
			a3Service.getProjectTeam(projectNdx, factoryNdx).then(function (data) {
				vm.projectTeam = data;
			});
			
			a3Service.getProjectIssues(projectNdx, factoryNdx).then(function (data) {
				var issues = [];
				if (data && data.length > 0) {
					issues = data.filter(function (issue) {
						return (issue.stateType !== 'Completed');
					});
				}
				vm.hasIssues = issues.length > 0 ? true : false;
				vm.projectIssues = issues;
			});
			
			a3Service.getProjectTasks(projectNdx, 'S', undefined, factoryNdx).then(function (data) {
				vm.hasCurrentActivity = data.length > 0 ? true : false;
				vm.projectTasksStarted = data;
			});
			
			a3Service.getProjectTasks(projectNdx, 'C', true, factoryNdx).then(function (data) {
				vm.hasAccomplishments = data.length > 0 ? true : false;
				vm.projectTasksAccomplished = data;
			});
			
			if (!vm.isSupplier) {
				a3Service.getProjectDocuments(projectNdx, factoryNdx).then(function (data) {
					vm.hasDocuments = data.length > 0 ? true : false;
					vm.projectDocuments = data;
				});
			}
			
			a3Service.getProjectTasks(projectNdx, 'P', true, factoryNdx).then(function (data) {
				vm.hasPendingTasks = data.length > 0 ? true : false;
				vm.projectTasksPending = data;
			});
			
			getTasks();
		}

		function setSavingsByCategory(savingsByCategory) {
			angular.forEach(savingsByCategory, function (saving) {
				var key = saving.includeInTotal ? 'included' : 'notIncluded';
				angular.forEach(['target', 'actual'], function (savingType) {
					if (saving[savingType + 'SavingsValue'] !== 0) {
						vm.savingsGroups[savingType][key].push({
							'name': saving.categoryName,
							'amount': saving[savingType + 'SavingsValue']
						});
					}
				});
			});
		}

		function showMore(elm, ulList) {
			elm = elm.currentTarget;
			if (jQuery(elm).text() == 'Show More') {
				jQuery(ulList + ' .showMore').removeClass('hidden');
				jQuery(elm).text('Show Less');
			} else {
				jQuery(ulList + ' .showMore').addClass('hidden');
				jQuery(elm).text('Show More');
			}

		}

		function isAfterToday(date) {
			var todayDate = new Date().setHours(0, 0, 0, 0);
			var completionDate = new Date(date.toString());
			completionDate = completionDate.getTime() + completionDate.getTimezoneOffset() * 60000;
			if (todayDate > completionDate) {
				return true;
			} else {
				return false;
			}
		}

		function printPage() {
			window.print();
		}

		function toggleTeam() {
			vm.sectionMap.teamSection.shown = !vm.sectionMap.teamSection.shown;
			if (vm.sectionMap.teamSection.shown) {
				vm.sectionMap.teamSection.text = 'Hide Description, Team Members and Strategic Goals';
			} else {
				vm.sectionMap.teamSection.text = 'Show Description, Team Members and Strategic Goals';
			}
		}
		
		function getTasks() {
			a3Service.getProjectTasks(projectNdx, 'N', false, factoryNdx).then(function (tasksData) {
				vm.hasTasks = tasksData.length > 0 ? true : false;
				vm.tasksData = tasksData;
			});
		}

		function openDetail(task) {
			var modalScope = $scope.$new();
			$sce.trustAsHtml(task.description);
			$sce.trustAsHtml(task.detailedAction);
			if (task.description == '') {
				task.description = 'None';
			}
			if (task.detailedAction == '') {
				task.detailedAction = 'None';
			}
			modalScope.task = task;
			var opts = {
				scope: modalScope,
				templateUrl: 'taskModalContent.html',
				animation: false,
				windowTemplateUrl: '/application/f/core/loading-template.html',
				backdrop: 'static'
			};
			var instance = $uibModal.open(opts);
			modalScope.closeDialog = function () {
				instance.dismiss('cancel');
			};
		}

		function openDocument(docName) {
			a3Service.getProjectDocument(projectNdx, factoryNdx, docName);
		}

		function prioritySorting(sortOrder, taskDataSet, paramName) {
			var orderedData;
			var paramNameObj = {};
			paramNameObj.paramName = paramName;
			if (sortOrder === 'asc') {
				taskDataSet.sort(function (a, b) {
					var dataA = a3Service.getTaskPriority(a[paramNameObj.paramName]),
						dataB = a3Service.getTaskPriority(b[paramNameObj.paramName]);
					return dataA - dataB; //sort by priority descending
				});
				orderedData = taskDataSet;
			} else if (sortOrder === 'desc') {
				taskDataSet.sort(function (a, b) {
					var dataA = a3Service.getTaskPriority(a[paramNameObj.paramName]),
						dataB = a3Service.getTaskPriority(b[paramNameObj.paramName]);
					return dataB - dataA; //sort by priority descending
				});
				orderedData = taskDataSet;
			}
			return orderedData;
		}

		function dateSorting(sortOrder, taskDataSet, paramName) {
			var orderedData;
			var paramNameObj = {};
			paramNameObj.paramName = paramName;
			if (sortOrder === 'asc') {
				taskDataSet.sort(function (a, b) {
					var dateA = new Date(a[paramNameObj.paramName]),
						dateB = new Date(b[paramNameObj.paramName]);
					return dateA - dateB; //sort by date descending
				});
				orderedData = taskDataSet;
			} else if (sortOrder === 'desc') {
				taskDataSet.sort(function (a, b) {
					var dateA = new Date(a[paramNameObj.paramName]),
						dateB = new Date(b[paramNameObj.paramName]);
					return dateB - dateA; //sort by date descending
				});
				orderedData = taskDataSet;
			}
			return orderedData;
		}
		
		function closeA3Dialog() {
			jQuery('.no-print-on-a3').removeClass('no-print-on-a3');
			closeA3();
		}
		
		init();
	}
})();